import { NavbarProps } from './float-menu-types';
import { SiderStyled, IconStyled, IconWrapperStyled, MenuItemStyled, MenuTextStyled, MenuStyled } from './styled-components';
import Wallet from '@/assets/icons/wallet/wallet.svg';
import Home from '@/assets/icons/home/home.svg';
import HomeDark from '@/assets/icons/home-dark/home-dark.svg';
import WalletDark from '@/assets/icons/wallet-dark/wallet-dark.svg';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@/contexts/theme-context/useThemeContext';
import { LoginOutlined } from '@ant-design/icons';
import { useUserContext } from '@/contexts/user/useUserContext';
import IsConnectedWrapper from '../IsConnectedWrapper/IsConnectedWrapper';

const FloatMenu: React.FC<NavbarProps> = ({ handleClick }) => {
  const { isConnect, loading } = useUserContext();
  const location = useLocation();
  const theme = useTheme();
  const isDark = theme.theme.name === 'dark';

  const handleSelectItem = (item: string) => {
    if (handleClick) {
      handleClick(item); 
    }
  };

  const isHomeSelected = location.pathname === '/' || location.pathname === '/home';
  const isWalletSelected = location.pathname === '/wallet';

  return (
    <SiderStyled data-testid="sider-styled">
      <MenuStyled data-testid="menu-styled" >
        <MenuItemStyled
          data-testid="menu-item"
          $selected={isHomeSelected}
          onClick={() => handleSelectItem('/home')}
        >
          <IconWrapperStyled>
            <IconStyled 
                src={isDark ? Home : HomeDark}
                alt="Home" 
              />  
          </IconWrapperStyled>
          <MenuTextStyled>Home</MenuTextStyled>
        </MenuItemStyled>
        {isConnect ? 
        <IsConnectedWrapper>
          <MenuItemStyled
            data-testid="menu-item"
            $selected={isWalletSelected}
            onClick={() => handleSelectItem('/wallet')}
          >
            <IconWrapperStyled>
              <IconStyled 
                  src={isDark ? Wallet : WalletDark}
                  alt="Wallet" 
                />
            </IconWrapperStyled>
            <MenuTextStyled>Wallet</MenuTextStyled>
          </MenuItemStyled> 
        </IsConnectedWrapper> : 
        <MenuItemStyled
          data-testid="menu-item"
          $selected={true}
          onClick={() => !loading && handleSelectItem('/login')}
        >
          <IconWrapperStyled>
            <LoginOutlined />
          </IconWrapperStyled>
          <MenuTextStyled>Login</MenuTextStyled>
        </MenuItemStyled>
        }
      </MenuStyled>
    </SiderStyled>
  );
};

export default FloatMenu;
